const readablePercentage = a => Math.floor(a * 10000) / 100 + '%';

export default readablePercentage;
